const Skype = () => {
    return (
        <div className="flex cursor-pointer">
            <a href="skype:live:.cid.e67199ba9bde67a0?call" target={"_blank"} rel="noreferrer">
                <img src={'/logo-skype.svg'} alt="Skype"className="w-7" />
            </a>
        </div>
    )
}

export default Skype

